import { useState, useEffect } from 'react';
import { getAnimationClass } from './../utils';
import { realCompanies } from './data';

export default function RealCo({ onComplete, companyName }) {
  const [showP, setShowP] = useState(false);
  const [showCompanies, setShowCompanies] = useState(false);
  const [visibleElements, setVisibleElements] = useState(0);

  useEffect(() => {
    const timeouts = [];
    let currentTime = 500;

    timeouts.push(setTimeout(() => setShowP(true), currentTime));

    currentTime += 2000;
    timeouts.push(setTimeout(() => setShowCompanies(true), currentTime));

    realCompanies.forEach((_, index) => {
      currentTime += 500;
      timeouts.push(setTimeout(() => setVisibleElements(index + 1), currentTime));
    });

    currentTime += 3000;

    timeouts.push(setTimeout(() => onComplete?.(), currentTime));

    return () => timeouts.forEach(clearTimeout);
  }, [onComplete]);

  const normalizedTarget = (companyName || '').trim().toLowerCase();

  return (
    <>
      <h1 className="animate-fade-in">Real Company Accounts</h1>

      <p className={getAnimationClass(showP)}>
        In this level, you’ll sort the financial statement accounts of a real publicly traded company.
      </p>

      {showCompanies && (
        <div className={`transition-real-companies-container ${getAnimationClass(visibleElements > 0)}`}>
          {realCompanies.map((item, index) => {
            const isHighlighted = normalizedTarget
              && item.name.toLowerCase() === normalizedTarget;
            return (
              <div
                className={[
                  'transition-real-company',
                  isHighlighted ? 'highlighted' : '',
                  getAnimationClass(index < visibleElements),
                ].filter(Boolean).join(' ')}
                key={index}
              >
                <img
                  src={item.src}
                  alt={item.name}
                  width={item.width}
                />
              </div>
            );
          })}
        </div>
      )}
    </>
  );
}